import BaseService from "../BaseService";
import { API_BASE_URL_ENV } from "../../jsx/common/common";
import http from "../HttpService";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/hr/fingerprint-exclusions";
const apiUploadSheetEndpoint =
	API_BASE_URL_ENV() + "/admin/hr/fingerprint-attendance/upload";

export default class FingerprintExclusionService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	remove(id) {
		return http.delete(`${apiEndpoint}/branch/${id}`);
	}

	update(data) {
		const body = { ...data };
		return http.put(apiEndpoint, body);
	}

	postUploadSheet(file, data) {
		const formData = new FormData();
		formData.append("file", file);
		formData.append("processingMonth", data?.processingMonth);
		return http.post(apiUploadSheetEndpoint, formData);
	}
}
